import { Reducer } from 'redux'
import { MINT_ACTIONS } from './const'
import { ActionTypes, MintState } from './types'

const initialState: MintState = {
  configurations: {
    data: [],
    loading: false,
    error: null,
  },
  setup: {
    selectedAsset: null,
    selectedWallet: null,
    selectedBlockchainNetwork: null,
    loading: false,
    error: null,
  },
  transactions: {
    data: [],
    pagination: {
      page: 1,
      perPage: 20,
      total: 0,
    },
    filters: {
      asset: null,
      status: null,
      network: null,
      dateFrom: null,
      dateTo: null,
      search: '',
    },
    loading: false,
    error: null,
  },
  ui: {
    educationalBannerDismissed: false,
  },
}

export const mint: Reducer<MintState, ActionTypes> = (state = initialState, action) => {
  switch (action.type) {
    case MINT_ACTIONS.FETCH_CONFIGURATIONS_REQUEST:
      return {
        ...state,
        configurations: {
          ...state.configurations,
          loading: true,
          error: null,
        },
      }

    case MINT_ACTIONS.FETCH_CONFIGURATIONS_SUCCESS:
      return {
        ...state,
        configurations: {
          data: action.data,
          loading: false,
          error: null,
        },
      }

    case MINT_ACTIONS.FETCH_CONFIGURATIONS_FAILURE:
      return {
        ...state,
        configurations: {
          ...state.configurations,
          loading: false,
          error: action.error,
        },
      }

    case MINT_ACTIONS.SET_SELECTED_ASSET:
      return {
        ...state,
        setup: {
          ...state.setup,
          selectedAsset: action.asset,
        },
      }

    case MINT_ACTIONS.SET_SELECTED_WALLET:
      return {
        ...state,
        setup: {
          ...state.setup,
          selectedWallet: action.wallet,
        },
      }

    case MINT_ACTIONS.SET_SELECTED_BLOCKCHAIN_NETWORK:
      return {
        ...state,
        setup: {
          ...state.setup,
          selectedBlockchainNetwork: action.network,
        },
      }

    case MINT_ACTIONS.DISMISS_EDUCATIONAL_BANNER:
      return {
        ...state,
        ui: {
          ...state.ui,
          educationalBannerDismissed: true,
        },
      }

    case MINT_ACTIONS.FETCH_TRANSACTIONS_REQUEST:
      return {
        ...state,
        transactions: {
          ...state.transactions,
          loading: true,
          error: null,
        },
      }

    case MINT_ACTIONS.FETCH_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        transactions: {
          ...state.transactions,
          data: action.data,
          pagination: action.pagination,
          loading: false,
          error: null,
        },
      }

    case MINT_ACTIONS.FETCH_TRANSACTIONS_FAILURE:
      return {
        ...state,
        transactions: {
          ...state.transactions,
          loading: false,
          error: action.error,
        },
      }

    case MINT_ACTIONS.SET_TRANSACTION_FILTERS:
      return {
        ...state,
        transactions: {
          ...state.transactions,
          filters: {
            ...state.transactions.filters,
            ...action.filters,
          },
        },
      }

    default:
      return state
  }
}
